<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="none"
    >
        <path
            d="M1 6.81185C3.01667 4.75518 5.82667 3.47852 8.93444 3.47852C12.0422 3.47852 14.8522 4.75407 16.8689 6.81185"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8.99989 12.6463C10.6874 12.6463 12.0554 11.2782 12.0554 9.59071C12.0554 7.90318 10.6874 6.53516 8.99989 6.53516C7.31235 6.53516 5.94434 7.90318 5.94434 9.59071C5.94434 11.2782 7.31235 12.6463 8.99989 12.6463Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M3.46789 4.95537L2.05566 2.64648"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.11105 3.63889L6.58105 1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.5322 4.95537L15.9444 2.64648"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.8887 3.63889L11.4187 1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
